import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteCushionChargePolicy } from 'api/company/deleteCushionChargePolicy'
import { cushionChargePoliciesKey } from './keys'

export function useDeleteCushionChargePolicyMutation(companyId: number) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (policyId: number) =>
      deleteCushionChargePolicy({ companyId, policyId }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: cushionChargePoliciesKey(companyId),
      })
    },
  })
}
